/** Local event deduplication. Keys stay local; never include secrets. */
const fallback = new Set<string>();
function claim(key: string, lifetime: 'session' | 'persistent'): boolean {
  const storageKey = `lm.analytics.once.${key}`;
  try {
    const storage = lifetime === 'session' ? sessionStorage : localStorage;
    if (storage.getItem(storageKey)) return false;
    storage.setItem(storageKey, '1');
    return true;
  } catch {
    // Blocked storage can deduplicate within this page, not across reloads.
    const memoryKey = `${lifetime}:${storageKey}`;
    if (fallback.has(memoryKey)) return false;
    fallback.add(memoryKey);
    return true;
  }
}
export function claimSessionEvent(key: string): boolean { return claim(key, 'session'); }
export function claimPersistentEvent(key: string): boolean { return claim(key, 'persistent'); }
